import {internalApi} from "../../../common/axios";
import {useQueryBase} from "../../../shared/hooks/useHookBase";
import toast from "react-hot-toast";

const fetchBadgeMasterData = async () => {
    const response = await internalApi.get(`badge_master`);
    return response.data.rows;
}

export const useBadgeMasterData = () => {
    return useQueryBase(['badgeMasterData'], fetchBadgeMasterData, {staleTime: 0});
}

export const saveBadgeMaster = async (data) => {
    try {
        const res = await internalApi.post('badge_master', {data});
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("저장 실패");
    }
}

export const deleteBadgeMaster = async (seq) => {
    try {
        const res = await internalApi.delete(`badge_master/${seq}`);
        toast.success(res.data.message);
    } catch (e) {
        console.error(e);
        toast.error("삭제 실패");
    }
}
